import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, Stack, Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { FC, useContext } from 'react'

import { TABLET_WIDTH_BREAKPOINT } from '../../config/breakPoints'
import { NavVisibilityContext, WindowSizeContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { MUI_ICON_BUTTON_HEIGHT, MUI_ICON_BUTTON_WIDTH } from '../../styles'
import { BottomDrawerContents } from './BottomDrawerContents'
import { TopDrawerContents } from './TopDrawerContents'

export const DrawerContents: FC = () => {
  const { iconsOnly, setIconsOnly, setStayOpen } =
    useContext(NavVisibilityContext)
  const { width } = useContext(WindowSizeContext)
  const { shopProfile } = useContext(AppContext)

  const overTabletBreakpoint = width >= TABLET_WIDTH_BREAKPOINT

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={
          iconsOnly && overTabletBreakpoint ? 'space-evenly' : 'space-between'
        }
        sx={{
          flexBasis: 'content',
          flexShrink: 1,
          paddingX: '8px',
          paddingY: '16px',
          minHeight: 60,
          maxHeight: 60,
          my: 2
        }}>
        {(!iconsOnly || !overTabletBreakpoint) && (
          <Typography
            fontSize={16}
            data-testid="shopName"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
            {shopProfile?.info?.name || ''}
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly'
          }}>
          {overTabletBreakpoint ? (
            <IconButton
              sx={{
                width: MUI_ICON_BUTTON_WIDTH,
                height: MUI_ICON_BUTTON_HEIGHT,
                color: 'primary.contrastText'
              }}
              onClick={() => setIconsOnly(!iconsOnly)}>
              <MenuIcon data-testid="DrawerButton" />
            </IconButton>
          ) : (
            <IconButton
              sx={{
                width: MUI_ICON_BUTTON_WIDTH,
                height: MUI_ICON_BUTTON_HEIGHT,
                color: 'primary.contrastText'
              }}
              data-testid="HideNavMenuButton"
              onClick={() => setStayOpen(false)}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexShrink: 0,
          flexGrow: 1
        }}>
        <Box sx={{ flexShrink: 1 }}>
          <TopDrawerContents />
        </Box>
        <Box sx={{ flexBasis: 'content', flexShrink: 0 }}>
          <BottomDrawerContents />
        </Box>
      </Box>
    </Box>
  )
}
